<template>
  <div class="product__price-container">
    <div class="product__price">
      <span class="_from hide-for-small-only">Vanaf</span>
      <span class="price" v-if="fromPrices.totalPriceInclTax > 0 || totalPrices.totalPriceInclTax > 0">
        <span class="price__old-price" v-if="hasDiscount">
          {{ totalPrices.priceInclTax.priceFormat() }}
        </span>
        {{ (fromPrices.totalPriceInclTax > 0 && totalPrices.totalPriceInclTax === 0) ? fromPrices.totalPriceInclTax.priceFormat() : totalPrices.totalPriceInclTax.priceFormat() }}
      </span>
      <span class="price__tax">{{ $t('inclusief btw') }}</span>
    </div>
    <slot name="external_delivery"></slot>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component(
    {
      name: 'catalog-product-price'
    }
  )

  export default class extends Vue {
    @Prop() private readonly position: string;

    private get totalPrices(): number {
      return this.$store.getters['CatalogProduct/totalPrices'];
    }

    private get fromPrices(): number {
      return this.$store.getters['CatalogGroupedProduct/fromPrices'];
    }

    private get hasDiscount(): boolean {
      const prices: any = this.totalPrices;
      return Boolean(prices && prices.totalPriceInclTax > 0 && prices.totalPriceInclTax !== prices.priceInclTax);
    }
  }
</script>
